import { render } from "./UmedidaList.vue?vue&type=template&id=b2fe6c96&scoped=true"
import script from "./UmedidaList.vue?vue&type=script&lang=js"
export * from "./UmedidaList.vue?vue&type=script&lang=js"

import "./UmedidaList.vue?vue&type=style&index=0&id=b2fe6c96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fe6c96"]])

export default __exports__